module.exports = __webpack_public_path__ + "img/exchange-rate.165ceddb.svg";